import {createContext} from 'react';

export const ThemeContext = createContext({
    setTheme: (theme: string) => {
    },
    getTheme: (): string => '',
});
